import { render } from "./TempleatPage.vue?vue&type=template&id=51201e9c&scoped=true"
import script from "./TempleatPage.vue?vue&type=script&lang=js"
export * from "./TempleatPage.vue?vue&type=script&lang=js"

import "./TempleatPage.vue?vue&type=style&index=0&id=51201e9c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51201e9c"]])

export default __exports__